import React from "react"
import {parseManualReview} from "./parse"
import {ManualReviewInsights} from "../../resources/application"
import {Badge} from "../Badge/Badge"
import {startCase} from "lodash"

export const ManualReviewRecommendation: React.FC<{
	data: ManualReviewInsights
}> = ({data}) => {
	const {recommendation, summary, reasons} = parseManualReview(data)

	return (
		<div className={"ai-insights-manual-review-recommendation"}>
			<div className="recommendation-container">
				<h3 className="light">Recommendation:</h3>
				<Badge text={startCase(recommendation)} className="ml-3 manual-review-recommendation-badge" />
			</div>
			<div>
				<h3 className="with-divider">Application Summary</h3>
				<p>{summary}</p>
			</div>
			<div>
				<h3 className="with-divider">{reasons.length > 1 ? "Reasons" : "Reason"}</h3>
				<ul>
					{reasons.map((r, i) => (
						<li key={i}>{r}</li>
					))}
				</ul>
			</div>
		</div>
	)
}
